import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { WorkspaceRoutes } from "./WorkspaceRoutes";
import { ProductUUID } from "namirasoft-api-product";
import { WorkspaceMenus } from "./WorkspaceMenus";
import { WorkspaceProps } from "./WorkspaceProps";
import { BaseColumnFormatter, BooleanFormatter, IDFormatter, StringFormatter, DateTimeFormatter, ForeColorFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { WorkspaceRow } from "namirasoft-workspace/dist/row/WorkspaceRow";
import { WorkspaceInputRow } from "namirasoft-workspace/dist/row/WorkspaceInputRow";
import { NamirasoftMap } from "namirasoft-site-map";
import { IStorageLocal } from "namirasoft-core";

export class WorkspaceEntities
{
	static workspace(props: NSARouterMakerResult & WorkspaceProps, callback: () => void): IEntityInfo<WorkspaceRow, WorkspaceInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_WORKSPACE,
			name: "workspace",
			tables: [{ table: namirasoft.workspace.tables.workspace, required: true }],
			client: {
				getListURL: () => WorkspaceRoutes.WorkspaceList,
				getNewURL: () => WorkspaceRoutes.WorkspaceNew,
				getCopyURL: (id: string) => WorkspaceRoutes.WorkspaceCopy(id),
				getEditURL: (id: string) => WorkspaceRoutes.WorkspaceEdit(id),
				getViewURL: (id: string) => WorkspaceRoutes.WorkspaceView(id),
				getMenus: (getIDs) => { return { "Workspace": [WorkspaceMenus.setDefault(props, getIDs, callback), WorkspaceMenus.setCurrent(props, getIDs, callback)] } },
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.workspace.tables.workspace.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.workspace.tables.workspace.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.workspace.tables.workspace.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.workspace.tables.workspace.columns.product_ids, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.workspace.tables.workspace.columns.default, new ForeColorFormatter(new BooleanFormatter("Default", ""), { true: "green" })),
						BaseColumnFormatter.getColumn(namirasoft.workspace.tables.workspace.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.workspace.tables.workspace.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.workspace.tables.workspace.columns.updated_at, new DateTimeFormatter())
					];
				}
			},
			server: {
				value_list: props.servers.workspace.value.List,
				get: props.servers.workspace.workspace.Get,
				list: props.servers.workspace.workspace.List,
				create: props.servers.workspace.workspace.Create,
				update: props.servers.workspace.workspace.Update,
				delete: props.servers.workspace.workspace.Delete,
			}
		};
	}
}